import { Box, Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon } from "@chakra-ui/react";
import type { MenuExtendedProps } from "config/menus/menus.d";
import { accordionButtonStyles } from "./MenuLinkWithSubmenu.styles";
import { SubmenuContent } from "./SubmenuContent";

export const MenuLinkWithSubmenuMobile = ({
  menulink,
  submenu,
}: {
  submenu: MenuExtendedProps["subMenu"];
  menulink: JSX.Element;
}) => (
  <Accordion allowToggle>
    <AccordionItem border="none" bg="transparent">
      <AccordionButton
        py={0}
        pl={0}
        fontSize="lg"
        borderRadius="sm"
        data-testid="open-kyr-items"
        sx={accordionButtonStyles}
      >
        <Box flex="1" textAlign="left">
          {menulink}
        </Box>
        <AccordionIcon boxSize={6} />
      </AccordionButton>
      <AccordionPanel px={4}>
        <SubmenuContent
          submenu={submenu}
          fontSize="md"
          color="greyscale.600"
          _hover={{ color: "primary.500" }}
          data-testid="kyr-list-items"
        />
      </AccordionPanel>
    </AccordionItem>
  </Accordion>
);
